import { render, staticRenderFns } from "./InputFeatures.vue?vue&type=template&id=00d0914a"
import script from "./InputFeatures.vue?vue&type=script&lang=js"
export * from "./InputFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports